export enum DiscountType {
  GIFTCARD = 'giftcard',
  COUPON = 'coupon'
}
